
import ListaBomba from "./ListaBomba";
import AlertDialogOnClose from "../../../../components/admin/AlertDiologOnClose";
export default function BombaForm() {
    return (
        <AlertDialogOnClose nome={"Bomba"} placeholder={"Insira o nome da bomba"}>
            <ListaBomba />
        </AlertDialogOnClose>
    )
} 